angular.module('property-deal')
    .component('propertyDealExcludeFromStatisticsIcon', {
        bindings: {
            item: '<',
            allowToggle: '<',
            showSectionLabel: '<',
            showWhenFalse: '<'
        },
        templateUrl: 'app/property-deal/exclude-from-statistics-icon.html',
        controller: function (PropertyDealService, Principal) {
            this.PropertyDealService = PropertyDealService

            this.$onInit = () => {
                this.canToggle = Principal.hasAnyAuthority(["ROLE_PROPERTY_DEAL_EXCLUDE_FROM_STATISTICS"])
                this.recompute()
            }

            this.$onChanges = () => {
                this.recompute()
            }

            this.recompute = () => {
                this.toggleEnabled = this.allowToggle === true && this.canToggle === true
                this.isExcluded = !!(this.item && this.item.excludeFromStatistics)
                this.visible = this.isExcluded || (this.showWhenFalse === true && this.canToggle === true)
                this.tooltipKey = this.isExcluded
                    ? 'property-deal.exclude-from-statistics.toggle.include'
                    : 'property-deal.exclude-from-statistics.toggle.exclude'
            }

            this.toggle = ($event) => {
                if (!this.toggleEnabled || !this.item) {
                    return
                }
                if ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                }
                this.PropertyDealService.statisticsToggle(this.item)
            }
        }
    })
